import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useApiFetch } from '../../shared/api'

/**
 * Rename a team (PATCH /clubhouse/groups/{groupId}).
 *
 * Owner-only. The server enforces it; the Settings tab additionally hides the
 * control from everyone else, matching the mobile management menu where
 * "rename team" is offered to the owner but not to an admin.
 *
 * The team name is rendered from `GroupDto.name` on the teams list, the detail
 * header, the hunts pages and the calendar, so the my-groups query is
 * invalidated rather than the new name being patched into one cache entry —
 * every surface then re-reads from the one source of truth.
 */
export function useRenameGroup(groupId: string) {
  const call = useApiFetch()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (name: string) =>
      call<void>(`/clubhouse/groups/${encodeURIComponent(groupId)}`, {
        method: 'PATCH',
        body: JSON.stringify({ name }),
      }),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ['clubhouse', 'me', 'groups'] })
    },
  })
}
